import { render, staticRenderFns } from "./wt-upload-big-file.vue?vue&type=template&id=412db309&"
import script from "./wt-upload-big-file.vue?vue&type=script&lang=js&"
export * from "./wt-upload-big-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports